<ms-nav-tree [tree]="tree" (toggle)="toggleItem($event)" (selectEvent)="select($event)" (toggleMarkets)="onToggleMarkets()"></ms-nav-tree>
<ms-competition-tree *ngIf="sport" [sport]="sport" [tournaments]="tournaments" [stateless]="true"></ms-competition-tree>
